var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.messages, function (message, i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "pega-sent-message",
          class: { "pega-received-message": message.fromOthers },
          attrs: { "data-test": "message-" + i },
        },
        [
          _c("div", { staticClass: "boss-message-header-layout" }, [
            _c("span", { attrs: { "data-test": "send-date-" + i } }, [
              _vm._v(_vm._s(message.sendDate)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "boss-layout-block boss-message-when pega-break-all",
                attrs: { "data-test": "sender-" + i },
              },
              [
                _vm._v(
                  "\n        差出人：" +
                    _vm._s(message.senderInfo.name) +
                    " (" +
                    _vm._s(message.senderInfo.email) +
                    ")\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-layout-block" }, [
            _c(
              "div",
              { staticClass: "boss-message-mail-subject" },
              [
                _vm._v("\n        TO："),
                _vm._l(message.toReceivers, function (to, j) {
                  return _c(
                    "span",
                    {
                      key: "to-" + i + "-" + j,
                      attrs: { "data-test": "to-" + i + "-" + j },
                    },
                    [_vm._v(_vm._s(to.name) + " (" + _vm._s(to.email) + ")")]
                  )
                }),
                _c("br"),
                _vm._v("\n        CC："),
                _vm._l(message.ccReceivers, function (cc, j) {
                  return _c(
                    "span",
                    {
                      key: "cc-" + i + "-" + j,
                      attrs: { "data-test": "cc-" + i + "-" + j },
                    },
                    [_vm._v(_vm._s(cc.name) + " (" + _vm._s(cc.email) + ")")]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "pega-pre-wrap",
              attrs: { "data-test": "message-body-" + i },
              domProps: {
                innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody(message.body))),
              },
            }),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }